import appStore from '../utils/state';
import { ProductModalType } from '../types';

export default class ModalButton extends HTMLElement {
  private button: HTMLButtonElement | null = null;

  private type: ProductModalType | null = null;

  private onButtonClickBound = this.onButtonClick.bind(this);

  constructor() {
    super();
  }

  connectedCallback(): void {
    this.type = this.dataset.type as ProductModalType;
    this.button = this.querySelector('[data-modal-button-ref="button"]');

    this.addEventListeners();
  }

  addEventListeners(): void {
    if (this.button) {
      this.button.addEventListener('click', this.onButtonClickBound);
    }
  }

  removeEventListeners(): void {
    if (this.button) {
      this.button.removeEventListener('click', this.onButtonClickBound);
    }
  }

  onButtonClick(): void {
    if (this.type) {
      switch (this.type) {
        case 'details-and-care':
          appStore.actions.openDetailsAndCareModal();
          break;
        case 'size-and-fit':
          appStore.actions.openSizeAndFitModal();
          break;
        case 'sustainability':
          appStore.actions.openSustainabilityModal();
          break;
        case 'delivery-and-returns':
          appStore.actions.openDeliveryAndReturnsModal();
          break;
        case 'description':
          appStore.actions.openDescriptionModal();
          break;
        case 'giftcard-instructions':
          appStore.actions.openGiftcardInstructionsModal();
          break;
      }
    }
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('modal-button', ModalButton);
